import { render, staticRenderFns } from "./PCLanding.vue?vue&type=template&id=24862bcb&scoped=true&"
import script from "./PCLanding.vue?vue&type=script&lang=ts&"
export * from "./PCLanding.vue?vue&type=script&lang=ts&"
import style0 from "./PCLanding.vue?vue&type=style&index=0&id=24862bcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24862bcb",
  null
  
)

export default component.exports